import api from "@common/api/index.js";

class TabItem {
  constructor(name, displayName, expData) {
    /**
     * 名称
     */
    this.name = name;
    /**
     * 显示名称
     */
    this.displayName = displayName;

    let isStatistic = false;
    // TODO:运行分析默认数据项单位
    const unitObj = {
      101: "V",
      102: "A",
      103: "kW",
      201: "V",
      202: "V",
      203: "V",
      204: "V",
      205: "V",
      206: "V",
      207: "A",
      208: "A",
      209: "A",
      210: "A",
      211: "kW",
      212: "kW",
      213: "kW",
      214: "kW",
      215: "kW",
      216: "kW",
      217: "kW",
      218: "kW",
      219: "",
      220: "",
      221: "",
      222: "",
      223: "",
      224: "",
      225: "",
      226: "",
      227: "Hz",
      228: "",
      229: "",
      230: "",
      231: "",
      232: "",
      233: "%",
      234: "",
      235: "%",
      242: "%",
      243: "%",
      249: "V",
      250: "V",
      251: "V",

      403: "m³",
      404: "Pa",
      405: "kg/m³",
      406: "",
      407: "",
      408: "",
      409: "",
      501: "°C",
      502: "",
      601: "",
    };

    for (let i = 0; i < expData.length; i++) {
      if (expData[i].dataType !== "measuring") {
        isStatistic = true;
      }
      if (!expData[i].unit) {
        if (unitObj[expData[i].pointCode]) {
          expData[i].unit = unitObj[expData[i].pointCode];
        } else {
          expData[i].unit = "";
        }
      }
    }
    /**
     * 是否为统计项,  true  不显示数据类型选择
     */
    this.isStatistic = isStatistic;

    /**
     * 数据项
     */
    this.expData = expData;
  }
}

/**
 * 判断该pointCode是否可用于运行分析
 * @param {*} pointCode
 */
function judgePointCode(pointCode) {
  // 排除谐波量
  if (pointCode <= 40000 && pointCode >= 10000) {
    return false;
  }
  return true;
}

/**
 *
 * @param {*} pointCode
 */
function getPointCodeDataType(pointCode) {
  const code = {
    quantity: [
      100229,
      100230,
      100231,
      100232,
      100401,
      100402,
      100701,
      100801,
      233,
      1000,
      101001
    ],
    measuring: [
      101,
      102,
      103,
      201,
      202,
      203,
      204,
      205,
      206,
      207,
      208,
      209,
      210,
      211,
      212,
      213,
      214,
      215,
      216,
      217,
      218,
      219,
      220,
      221,
      222,
      223,
      224,
      225,
      226,
      227,
      228,
      229,
      230,
      231,
      232,
      234,
      235,
      242,
      243,
      249,
      250,
      251,
      401,
      402,
      403,
      404,
      405,
      406,
      407,
      408,
      409,
      501,
      502,
      601,
      701,
      410,
      411,
      412,
      413,
      414,
      416,
      264,
      265,
    ],
  };
  let ret = "measuring";
  for (const key in code) {
    for (let i = 0; i < code[key].length; i++) {
      if (code[key][i] == pointCode) {
        return key;
      }
    }
  }
  return ret;
}

async function loadAllMeasuringData(
  measures,
  startTime,
  endTime,
  allMeasuringData,
  fn
) {
  const res = await api.measuring.getMeasuringValueAll2(
    measures,
    startTime,
    endTime,
    0,
    5000
  );
  for (let i = 0; i < res.data.length; i++) {
    const element = res.data[i];
    if (!allMeasuringData[toKey(element.pointCode, element.pointNumber)]) {
      allMeasuringData[toKey(element.pointCode, element.pointNumber)] = [];
    }
    allMeasuringData[
      toKey(element.pointCode, element.pointNumber)
    ] = allMeasuringData[toKey(element.pointCode, element.pointNumber)].concat(
      element.data.data
    );
  }
  if (
    new Date(res.data[0].data.endTime).getTime() -
      new Date(endTime).getTime() !==
    0
  ) {
    //一直load数据
    loadAllMeasuringData(
      measures,
      res.data[0].data.endTime,
      endTime,
      allMeasuringData,
      fn
    );
  } else {
    fn();
  }
}

function toKey(pointCode, pointNumber) {
  return pointCode + "_" + pointNumber;
}

export default {
  /**
   * 获取运行分析数据
   * @param {*} measureId 测点Id
   * @param {*} point [{pointCode,pointNumber}]
   * @param {*} type 类型  1为统计   2.为采集间隔
   * @param {*} dateType 时间类型 hour 按时  day 按天  如果类型为1 则不能为null
   */
  getRunningAnalyseChartData(
    measureId,
    point,
    type,
    dateType,
    startTime,
    endTime
  ) {
    
    return new Promise((resolve, reject) => {
      if (type == 2) {
        // 按采集间隔
        let measures = [];
        let measuringData = {};
        for (let i = 0; i < point.length; i++) {
          const pointItem = point[i];
          measures.push({
            measureId: measureId,
            pointNumber: pointItem.pointNumber,
            pointCode: pointItem.pointCode,
          });
          measuringData[toKey(pointItem.pointCode, pointItem.pointNumber)] = [];
        }
        // 递归获取采集间隔数据
        loadAllMeasuringData(
          measures,
          startTime,
          endTime,
          measuringData,
          () => {
            resolve({ data: measuringData });
          }
        );
      } else {
        let apiArr = [];
        // 统计数据项的参数
        let quantityMeasures = [];
        // 采集数据项的参数
        let measuringMeasures = [];
        let apiTypeData = [];
        let quantityData = {};
        for (let i = 0; i < point.length; i++) {
          const pointItem = point[i];
          quantityData[toKey(pointItem.pointCode, pointItem.pointNumber)] = [];
          const type = getPointCodeDataType(point[i].pointCode);
          if (type == "quantity") {
            quantityMeasures.push({
              measureId: measureId,
              pointNumber: pointItem.pointNumber,
              pointCode: pointItem.pointCode,
            });
            apiTypeData.push("quantity" + dateType);
          } else {
            measuringMeasures.push({
              measureId: measureId,
              pointNumber: pointItem.pointNumber,
              pointCode: pointItem.pointCode,
            });
            apiTypeData.push("measuring");
          }
        }

        if (dateType === "hour") {
          if (quantityMeasures.length > 0) {
            apiArr.push(
              api.quantity.getQuantityHour2(
                quantityMeasures,
                startTime,
                endTime,
                null
              )
            );
          }
          if (measuringMeasures.length > 0) {
            apiArr.push(
              api.measuring.getMeasuringValueHour2(
                measuringMeasures,
                startTime,
                endTime,
                0
              )
            );
          }
        } else if(dateType === "day") {
          if (quantityMeasures.length > 0) {
            apiArr.push(
              api.quantity.getQuantityDay3(
                quantityMeasures,
                startTime,
                endTime,
                null
              )
            );
          }
          if (measuringMeasures.length > 0) {
            apiArr.push(
              api.measuring.getMeasuringValueDay2(
                measuringMeasures,
                startTime,
                endTime,
                0
              )
            );
          }
        }else  {
          if (quantityMeasures.length > 0) {
            apiArr.push(
              api.quantity.getQuantityMonth2(
                quantityMeasures,
                startTime,
                endTime,
                null
              )
            );
          }
          if (measuringMeasures.length > 0) {
            apiArr.push(
              api.measuring.getMeasuringValueMonth2(
                measuringMeasures,
                startTime,
                endTime,
                0
              )
            );
          }
        }

        Promise.all(apiArr).then((resArr) => {
          for (let i = 0; i < resArr.length; i++) {
            const res = resArr[i];
            const type = apiTypeData[i];
            // 对不同的接口进行不同的处理
            if (type == "measuring") {
              for (let j = 0; j < res.data.length; j++) {
                const item = res.data[j];
                quantityData[toKey(item.pointCode, item.pointNumber)] =
                  item.data.data;
              }
            } else if (type == "quantityhour"||type == "quantitymonth") {
              for (let j = 0; j < res.data.length; j++) {
                const item = res.data[j];
                quantityData[toKey(item.pointCode, item.pointNumber)] =
                  item.data;
              }
            } else if (type == "quantityday") {
              for (let j = 0; j < res.data.length; j++) {
                const item = res.data[j];
                quantityData[toKey(item.pointCode, item.pointNumber)] =
                  item.data[0];
              }
            } 
            let requestUrl=''
            if(dateType === "hour"){
              requestUrl=api.quantity.getQuantityDay3
            }else if(dateType === "day"){
              requestUrl=api.quantity.getQuantityMonth2
            }else{
              requestUrl=api.quantity.getQuantityYear2
            }
            let thisVal = {};
            if (quantityMeasures.length > 0) {
             requestUrl(quantityMeasures, startTime, endTime, 0)
                .then((res2) => {
                  if(!res2.data[0].data.length){
                    resolve({ data: quantityData, thisVal: thisVal });
                    return
                  }
                  const element = res2.data[0];
                  thisVal[toKey(element.pointCode, element.pointNumber)] =
                  element.data[0]?.value ?? element.data[0][0]?.value;
                  resolve({ data: quantityData, thisVal: thisVal });
                });
            } else {
              resolve({ data: quantityData, thisVal: thisVal });
            }
          }
        });
      }
    });
  },
  /**
   * 获取运行分析tabData
   * @param {*} measureId 测点Id
   * @param {*} paramTabData 自定义页面参数
   * @param {*} isCompound 是否复合
   */
  getRunningAnalyseTabData(measureId, paramTabData = [], isCompound) {
    return new Promise((resolve, reject) => {
      api.measure
        .getMeasuresExpressions(JSON.stringify([measureId]))
        .then((res) => {
          if (!res.success) {
            resolve({ data: res.errorStr });
            return;
          }
          let tabData = [];
          let allExpData = [];
          // 获取所有数据项
          for (let i = 0; i < res.data[0].expressionGroups.length; i++) {
            const group = res.data[0].expressionGroups[i];
            for (let j = 0; j < group.expression.length; j++) {
              const exp = group.expression[j];
              group.expression[j].dataType = getPointCodeDataType(
                exp.pointCode
              );
              // 是否可添加tab
              const bolAddTab = judgePointCode(exp.pointCode);
              if (bolAddTab) {
                allExpData.push(exp);
              }
            }
          }

          // 获取自定义组合的tab
          // 判断自定义页面参数是否为空，如果为空，那么直接使用档案库数据项，不为空直接使用自定义页面参数
          if (!isCompound) {
            for (let i = 0; i < paramTabData.length; i++) {
              const paramTab = paramTabData[i];
              let tabExpData = [];
              for (let j = 0; j < paramTab.point.length; j++) {
                for (let k = 0; k < allExpData.length; k++) {
                  const exp = allExpData[k];
                  if (exp.pointCode == paramTab.point[j].pointCode) {
                    if (
                      paramTab.point[j].pointNumber == "-" ||
                      exp.pointNumber == paramTab.point[j].pointNumber
                    ) {
                      // 设置单位
                      exp.unit = paramTab.point[j].unit;
                      tabExpData.push(exp);
                      // 判断该公式是否已经在自定义参数里面包含
                      allExpData[k].use = true;
                    }
                  }
                }
              }
              if (tabExpData.length > 0) {
                const tabItem = new TabItem(
                  "tab" + i,
                  paramTab.name,
                  tabExpData
                );
                tabData.push(tabItem);
              }
            }
          } else {
            for (let i = 0; i < paramTabData.length; i++) {
              const paramTab = paramTabData[i];
              let tabExpData = [];
              for (let j = 0; j < paramTab.point.length; j++) {
                for (let k = 0; k < allExpData.length; k++) {
                  const exp = allExpData[k];
                  if (exp.pointCode == paramTab.point[j].pointCode) {
                    if (
                      paramTab.point[j].pointNumber == "-" ||
                      exp.pointNumber == paramTab.point[j].pointNumber
                    ) {
                      // 设置单位
                      exp.unit = paramTab.point[j].unit;
                      tabExpData.push(exp);
                      // 判断该公式是否已经在自定义参数里面包含
                      allExpData[k].use = true;
                    }
                  }
                }
              }
              if (tabExpData.length > 0) {
                const tabItem = new TabItem(
                  "tab" + i,
                  paramTab.name,
                  tabExpData
                );
                tabData.push(tabItem);
              }
            }
            for (let i = 0; i < allExpData.length; i++) {
              if (!allExpData[i].use) {
                const tabItem = new TabItem(
                  allExpData[i].name,
                  allExpData[i].displayName,
                  [allExpData[i]]
                );
                tabData.push(tabItem);
              }
            }
          }
          console.log(tabData);
          resolve({ data: tabData });
        });
    });
  },
};
